import React from 'react';
import { Trans } from 'react-i18next';
import { ExchangeModalLink } from '../../../components/ExchangeModalLink';
import { Hint } from '../../../components/Hint';

interface Props {
  currency: string;
}

export const Warning: React.FC<Props> = ({ currency }) => (
  <>
    {currency === 'RUB' && (
      <Hint>
        <Trans i18nKey="toCard:You can withdraw only rubles to a card issued by Russian bank">
          You can withdraw only rubles to a card issued by Russian bank. To do this{' '}
          <ExchangeModalLink>exchange dollars for rubles</ExchangeModalLink>
        </Trans>
      </Hint>
    )}
  </>
);
